import Intrests from "./Intrests";

export function About() {
  return (
    <div>
      <p>
        👋 Hello there! I'm a passionate web developer with a knack for crafting
        engaging and dynamic user interfaces. My expertise lies in leveraging
        cutting-edge technologies to build robust and scalable web applications.
      </p>
      <br />
      <p>
        🚀 My primary front-end tool of choice is React.js, where I excel in
        creating interactive and seamless user experiences. Whether it's
        developing single-page applications or integrating complex state
        management, React is my go-to framework for building modern web
        interfaces.
      </p>
      <br />
      <p>
        🌐 On the back-end, I wield the power of Express.js to develop efficient
        and scalable server-side applications. Handling routes, middleware, and
        APIs is where Express.js truly shines, allowing me to create a solid
        foundation for web applications.
      </p>
      <br />
      <p>
        💾 When it comes to data management, MongoDB is my preferred NoSQL
        database. I thrive on designing and implementing database schemas that
        align with the dynamic needs of web applications, ensuring optimal
        performance and scalability.
      </p>
      <br />
      <p>
        🖥️ Fluent in the trio of web development essentials - HTML, CSS, and
        JavaScript - I bring a keen eye for design and a commitment to creating
        visually appealing and responsive websites.
      </p>
      <br />
      <p>
        🧠 Additionally, my strong foundation in data structures is reflected in
        my problem-solving skills, having successfully tackled over 250
        questions on LeetCode. This proficiency allows me to optimize algorithms
        and enhance the efficiency of application, ensuring they stand out in
        terms of both functionality and performance.
      </p>
      <br />
      <p>
        📈 Continuous learning is at the core of my professional journey, and I
        stay updated with the latest trends and best practices in web
        development to ensure that the solutions I provide are always at the
        forefront of technology.
      </p>
      <br />
      <p>Let's collaborate to turn your ideas into exceptional web experiences! 💻✨</p>
      <br />
      <br />
      <Intrests/>
      <br />
    </div>
  );
}
